<!-- =========================================================================================
    File Name: Email.vue
    Description: Email Application (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<!--  -->
<template>
      <div>
        <vx-card :title="$displayLabel(detail, 'module_name')">
          <module-form
            class="mt-4"
            :delegatorUrl="detail.api_delegator"
            :detailProp="detail"
            :blockDataProp="blockData"
            :permissionsProp="permissions"
            :enableEditProp="enableEdit"
            v-show="!showEmptyDataMessage" action-type="add"
          />
          <vs-alert icon="warning" active="true" color="warning" class="my-5" v-show="showEmptyDataMessage">
              <span>Acesso negado para adicionar registro.</span>
          </vs-alert>
        </vx-card>
      </div>
</template>

<script>

// import ModuleForm from './ModuleForm'
import ModuleForm from '../../../components/custom-modules/CustomModuleForm.vue'
import { Edit2Icon } from 'vue-feather-icons'
import { performFetch } from '../../../helpers'

export default {
  components: {
    ModuleForm,
    Edit2Icon
  },
  data () {
    return {
      showEmptyDataMessage: false,
      fieldData: {},
      fieldModel: {},
      enableEdit: {},
      detail: {},
      blockData: [],
      permissions: {},
      activeTab: 0

    }
  },
  watch: {
    async activeTab() {
      if (this.activeTab === 0) {
        await this.getData()
      }
    },
    async '$route.params.moduleHash'(value) {
      this.$vs.loading({type: 'default'})
      await this.getData()
    }
  },
  computed: {

  },
  methods: {

  },
  async created () {
    this.$vs.loading({type: 'default'})
    await this.getData()
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('auth/SET_CURRENT_MODULE_NAME', null)
    next()
  },
  mounted () {

  },
  methods: {
    async getData () {

      const requestBody = {
        application_token: this.$store.state.auth.app_token,
        module_token: this.$route.params.moduleHash,
        session_token: this.$store.state.auth.token
      }

      // await fetch(`${this.$store.state.auth.api_url}`, {
      //   method: 'POST', headers: {"Content-Type": "application/json"},
      //   body: JSON.stringify({
      //     command: 'add_module_row_parameters',
      //     parameters: requestBody
      //   })
      // })

      return await performFetch(this.$store.state.auth.api_url, {
          command: 'add_module_row_parameters',
          parameters: requestBody
        })
        .then(async (response) => {
          this.$vs.loading.close()
          if (response.status === 200) {
            response.json().then(async (responseData) => {
              this.detail = responseData.detail
              document.title = `${document.title.split(' | ')[0]} | ${this.$displayLabel(responseData.detail, 'module_name')}`
              this.$store.commit('auth/SET_CURRENT_MODULE_NAME', { module_name: responseData.detail.module_name, module_name_en: responseData.detail.module_name_en })
              if (responseData.payload.length > 0) {
                this.detail.module_hash = this.$route.params.moduleHash
                this.blockData = responseData.payload
                this.permissions = responseData.permissions
              } else {
                this.showEmptyDataMessage = !this.showEmptyDataMessage
              }
            })
          } else if (response.status == 401) {
            setApplicationLocalStorageItem('lastUrl', btoa(window.location.pathname))
            this.$store.dispatch('auth/signOut')
          } else {
            this.$vs.loading.close()
            this.showEmptyDataMessage = !this.showEmptyDataMessage
          }
        })
        .catch((e) => {
          this.$vs.loading.close()
          this.showEmptyDataMessage = !this.showEmptyDataMessage
          throw new Error(e.message)
        })
    }
  }
}

</script>


<style lang="scss">
.text-muted {
  font-size: 11px;
  color: #839bb3!important;
  padding-left: 5px;
}

.vs-input--label {
  font-size: 14px;
}
</style>
